"use client";
import React, { useState } from "react";
import Courses from "./Courses";
import Tests from "./Tests";
import Market from "./Market";
import NoItemsLabel from "@/components/shared/noItemsLabel/NoItemsLabel";

const index = ({ teacher }: any) => {
  const [tabIndex, setTabIndex] = useState<number>(1);

  return (
    <div className=" container flex flex-col gap-2 md:gap-5 mb-5">
      <div className=" bg-[#5F4D46] p-2 md:p-5 rounded-[10px]">
        <div className=" flex items-center gap-2 xl:gap-5 flex-wrap">
          <p
            className={`grow text-16  font-[500] text-center py-3 px-7  rounded-[10px] cursor-pointer ${
              tabIndex === 1
                ? "bg-primaryColor text-[#ffffff] "
                : "text-white bg-[#695750]"
            }`}
            onClick={() => setTabIndex(1)}
          >
            الكورسات
          </p>
          <p
            className={`grow text-16  font-[500] text-center py-3 px-3 md:px-7 text-nowrap  rounded-[10px] cursor-pointer ${
              tabIndex === 2
                ? "bg-primaryColor text-[#ffffff] "
                : "text-white bg-[#695750]"
            }`}
            onClick={() => setTabIndex(2)}
          >
            اختبارات شاملة
          </p>
        </div>
      </div>
      {tabIndex === 1 ? (
        teacher.courses?.length >= 1 ? (
          <Courses teacher={teacher} courses={teacher.courses} />
        ) : (
          <NoItemsLabel title="لا يوجد كورسات معروضة حتي الأن" />
        )
      ) : tabIndex === 2 ? (
        teacher.full_exams?.length >= 1 ? (
          <Tests exams={teacher.full_exams} teacher={teacher} />
        ) : (
          <NoItemsLabel title="لا يوجد اختبارات شاملة معروضة حتي الأن" />
        )
      ) : (
        <Market />
      )}
    </div>
  );
};

export default index;
